module.exports = __webpack_public_path__ + "static/ComplianceBoard-e0b13a8f3fa59fec8ac2d414173b6eec.jpg";